//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[[0,"WorkingCollectionName",0,0],[0,"WorkingObject",0,"TaggedObject",0]],[[[],"Dispose",{},0,0],[["objectTag","className"],"Collect",{},2,0],[["propertyName"],"AddProperty",{},1,0],[["propertyName","propertyValue"],"AddPropertyWithValue",{},2,0],[["collectionName","propertyName","propertyValue"],"AddPropertyWithValueToCollection",{R_:{createdProperty:"CAM.ObjectProperty"}},3,0],[[],"GetRoot",{R_:{root:"CAM.ObjectProperty"}},0,0],[["collectionName"],"GetCollection",{R_:{root:"CAM.ObjectProperty"}},1,0]],[]];
SPLM.CAM.ObjectPropertyManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ObjectPropertyManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;